import script from "./SyncProgressDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncProgressDialog.vue?vue&type=script&setup=true&lang=js"

import "./SyncProgressDialog.vue?vue&type=style&index=0&id=1224f8bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1224f8bc"]])

export default __exports__